<script>
import editView from "./editOrigin.vue";
import api from "@/api/projectApi";

export default {
  extends: editView,
  methods: {
    getData() {
      // this.$mask.open()

      if (this.dataId && !isNaN(this.dataId)) {
        this.$mask.open()
        this.isEdit = true;
        this.$http({
          url: api.soOrderHistory.getDataUrlNew,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$mask.close()
          this.formData = response.data.data
          //计算工单时长
          if(this.formData.stat<60){
            // 计算绝对时间差
            const diff = Math.abs(new Date(this.formData.createTime).getTime() - new Date().getTime());
            // 计算天数并取整
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            // 计算剩余小时并取整
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.orderDuration.days = days
            this.orderDuration.hours = hours
          }
          if (!response.data.data.soOrderDesignSaleRegisterDto){
            this.formData.soOrderDesignSaleRegisterDto = {}
          }
          if (this.lowerSiteDeal){
            this.orderRemarkParam.orderSiteId = this.formData.siteId
          }
          let soOrderSpecailFeeList = response.data.data.soOrderSpecailFeeDTOList
          this.srcList.push(this.formData.soOrderResultDTO.finishPic1)
          // this.srcList1=this.formData.soOrderResultDTO.finishPic1
          this.srcList.push(this.formData.soOrderResultDTO.finishPic2)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic3)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic4)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic5)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic6)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic7)
          soOrderSpecailFeeList.forEach(item => {
            if (item.feeType === 1) {
              this.soOrderSpecailFeeListToCompany.push(
                {
                  subjectName: item.subjectName,
                  qty: item.qty,
                  price: item.price,
                  amount: item.amount,
                  unit: item.unit
                }
              )
            } else if (item.feeType === 2) {
              this.soOrderSpecailFeeListToUser.push(
                {
                  subjectName: item.subjectName,
                  qty: item.qty,
                  price: item.price,
                  amount: item.amount,
                  unit: item.unit
                }
              )
            }
          })
          if(this.formData.soOrderPartsDTOList && this.formData.soOrderPartsDTOList.length>0){
          this.isType=this.formData.soOrderPartsDTOList[0].isCheck
        }
          if (this.formData.companyName && this.formData.companyName!='华帝股份有限公司'){
            this.showEngineerAmount = true;
          }

          var timeSeqs = this.formData.timeSequences;
          var a = 0;
          for (var i = 0; i < timeSeqs.length; i++) {
            if (timeSeqs[i].processDate != null) {
              a = i;
            }
          }
          this.timeSeq = a + 1;
          this.orderRemarkParam.orderId = this._dataId;
          this.orderRemarkParam.showInRemark = 1
          if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
            this.formData.soOrderComplainDTOList.forEach(item => {
              let list = []
              if (item.fileUrl1 != null) {
                list.push(item.fileUrl1)
              }
              if (item.fileUrl2 != null) {
                list.push(item.fileUrl)
              }
              if (item.fileUrl3 != null) {
                list.push(item.fileUrl3)
              }
              item.srcList = list
            })
          }
          if (this.formData.sfCheckBillDTOList != null && this.formData.sfCheckBillDTOList.length != 0) {
            this.formData.sfCheckBillDTOList.forEach(item => {
              if (item.stat == 1) {
                item.stat = '制单';
              } else if (item.stat == 2) {
                item.stat = '待确认';
              } else if (item.stat == 3) {
                item.stat = '待申诉';
              } else if (item.stat == 5) {
                item.stat = '已申诉';
              } else if (item.stat == 7) {
                item.stat = '执行考核';
              } else if (item.stat == 9) {
                item.stat = '已结算';
              } else if (item.stat == 19) {
                item.stat = '取消执行';
              } else if (item.stat == 99) {
                item.stat = '关闭';
              }

              if (item.isAbandon == 0) {
                item.isAbandon = '否';
              } else if (item.isAbandon == 1) {
                item.isAbandon = '是';
              }
            })
          }

          if (this.formData.soOrderProcessDTO != null) {
            if (this.formData.soOrderProcessDTO.firstBookDate.includes("00:00:00")) {
              var firstBookDates = this.formData.soOrderProcessDTO.firstBookDate.split(" ");
              this.formData.soOrderProcessDTO.firstBookDate = firstBookDates[0];
            }
          }
          if (this.formData.soOrderFeeAttributeList) {
            this.dataList = []
            let flag = 0
            let temp = []
            this.formData.soOrderFeeAttributeList.forEach(item => {
              if (flag < 4) {
                flag += 1
              } else {
                this.dataList.push(temp)
                flag = 0
                temp = []
              }
              temp.push({ key: item.feeAttributeName, value: item.amount })
            })
            if (temp.length > 0) {
              this.dataList.push(temp)
            }
          }
          if(this.formData.soOrderEnvironmentDTO){
            if (this.formData.soOrderEnvironmentDTO.environmentFile1){
              this.showEnvironmentFile.push(this.formData.soOrderEnvironmentDTO.environmentFile1)
            }
            if (this.formData.soOrderEnvironmentDTO.environmentFile2){
              this.showEnvironmentFile.push(this.formData.soOrderEnvironmentDTO.environmentFile2)
            }
            if (this.formData.soOrderEnvironmentDTO.environmentFile3){
              this.showEnvironmentFile.push(this.formData.soOrderEnvironmentDTO.environmentFile3)
            }

          }
          if (this.dealType == 'orderEdit' && this.formData.areaId != null && this.formData.areaId != '') {
            this.$http({
              url: api.basArea.echoAddressUrl,
              method: 'post',
              data: { id: this.formData.areaId }
            }).then(res => {
              this.areaOption = res.data.data.options
              this.areaValues = res.data.data.values
            })
          }
          console.log("历史单加载完毕")
          this.$store.commit('historicalWorkOrder/SET_HISTORICAL_WORKORDER_FORM_DATA', this.formData);

        }).catch(() => {
          this.$mask.close()
        })
      } else {
        this.enabled = true;
      }
    },
    userPhoneUnreal() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    handleApplyRealMobile() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAssignOrg() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAssignSite() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAssignSiteByMap() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAssignAgain() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doOrderFollowUp() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doOrderFollowUp() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doEditOrder() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doOrderClose() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    toHangUpCheck() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    toCancelCheck() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doOrderFinish() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    abandonAppeal() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    siteAccept() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAccept() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    handleReAssignEngineer() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    completionDialogCheck() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    simpleFinishOrderMed() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    cancelOrder() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    reDeal() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    // showSelectOrderDialog = true	显示选择订单对话框（不用管）
    // showCheckBillDialog = true	显示检查账单对话框  （权限控制）
    // showSupervisingDialog = true	显示监督对话框 （权限控制）
    // showSuspendDialog = true	显示挂起对话框 （不用管）
    // showReplaceBarcodeDialog = true	显示替换条码对话框
    generateOrderMed() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    createOrderMethod() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    exceptionOrderDealMed() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    completionDialogCheck() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doSiteRejectOrder() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doOrderSaleRegister() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAddOrder() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    doAddOrder() {
      this.$message({
        type: "warning",
        message: "历史工单不支持该操作"
      });
    },
    getTYJShortUrl() {
      this.$baseConfirm('您确定要前往问卷页面吗？').then(() => {

        this.$mask.open()
        this.$http({
          url: api.soOrderHistory.getTYJShortUrl,
          method: 'post',
          data: { id: this.formData.id, effect: 1, recommendValue: 1 }
        }).then(res => {
          if (res.data.type == "success") {
            this.$mask.close()
            window.open(res.data.data, '_blank')
            return;
          } else {
            this.$message({
              type: "error",
              message: "跳转失败"
            });
          }
        }).catch(error => {
          this.$mask.close()
        })
      })

    },
    createOrderAbnormal() { },
    btnClick() { },
  },
  created() {
    console.log("editMain created");
  }

};
</script>

<style lang="scss"></style>
